import { Injectable, Injector } from '@angular/core';
import { OdysseyOffcanvas, OffcanvasSize } from '@digiwall/core';
import { CustomerInvoiceDto } from '@digiwall/goliath-documents/proxy';
import { CustomerInvoiceCancellationComponent } from '../customer-invoice-cancellation/customer-invoice-cancellation.component';
import { ConfirmationService } from '@abp/ng.theme.shared';
import { LocalizationService } from '@abp/ng.core';
import { ActivatedRoute, Router } from '@angular/router';
import { DocHierarchyService } from '../../../components/doc-hierarchy/doc-hierarchy-item.service';

@Injectable({
  providedIn: 'root',
})
export class InvoiceCancellationService {
  constructor(
    private canvaService: OdysseyOffcanvas,
    private confirmationService: ConfirmationService,
    private injector: Injector,
    private localizationService: LocalizationService,
    private router: Router,
    private docHierarchyService: DocHierarchyService,
  ) {}

  public cancel(invoice: CustomerInvoiceDto, activeRoute: ActivatedRoute): void {
    if (invoice.isCancelled) {
      this.confirmationService.error(
        this.localizationService.instant('Doc::CustomerInvoice:CannotCancelSeveralTimes'),
        this.localizationService.instant('Doc::CustomerInvoice:AlreadyCancelled'),
        {
          hideCancelBtn: true,
          yesText: 'AbpAccount::Close',
        },
      );
      return;
    }

    const canvaRef = this.canvaService.open(CustomerInvoiceCancellationComponent, this.injector, {
      offcanvasPanelClass: OffcanvasSize.Small,
    });

    const invoiceCancellationComponent: CustomerInvoiceCancellationComponent =
      canvaRef.componentInstance;
    invoiceCancellationComponent.customerInvoice.set(invoice);
    invoiceCancellationComponent.hasBeenCancelledByRole.subscribe(cancellationResult => {
      canvaRef.close();
      this.router.navigate(
        [
          '../../',
          this.docHierarchyService.getRoute(cancellationResult.cancellationDocRole),
          cancellationResult.cancellationDocId,
        ],
        {
          relativeTo: activeRoute,
        },
      );
    });
  }
}
